module.exports = __webpack_public_path__ + "img/SWP_Axe_2H_03 (1).c5c5133d.png";